/**
 * Prevents libraries like Radix UI's react-remove-scroll from adding margin/padding
 * to compensate for scrollbar width. We use scrollbar-gutter: stable instead.
 *
 * This must be called on app initialization.
 */
export function preventScrollbarCompensation(): void {
  if (typeof window === 'undefined') return;

  const style = document.body.style;

  // Create a MutationObserver to watch for style changes
  const observer = new MutationObserver(() => {
    // Reset margin and padding if they get changed
    // Check current values to avoid infinite loops
    const currentMarginRight = style.getPropertyValue('margin-right');
    const currentPaddingRight = style.getPropertyValue('padding-right');

    if (currentMarginRight && currentMarginRight !== '0px') {
      style.setProperty('margin-right', '0px', 'important');
    }
    if (currentPaddingRight && currentPaddingRight !== '0px') {
      style.setProperty('padding-right', '0px', 'important');
    }
  });

  // Watch for style attribute changes on body
  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['style'],
  });

  // Initial cleanup
  style.setProperty('margin-right', '0px', 'important');
  style.setProperty('padding-right', '0px', 'important');
}
